// Copyright 2016 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { FrontEnd } from "datatypes/SoramaLocalApi";
import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import { IWorkflowModuleModalInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { ChannelSelection } from "services/ChannelSelection/ChannelSelection";
import { IChannelSelectionPresetService } from "services/ChannelSelection/IChannelSelectionPresetService";

@autoinject
export class ChannelSelectionModal implements IModal<ChannelSelectionModalState, ChannelSelectionModalReturnState> {
    private presets: ChannelSelection[];
    private frontEnd: FrontEnd;
    private modalInstance: IWorkflowModuleModalInstance<ChannelSelectionModalState, ChannelSelectionModalReturnState>;
    private returnState: ChannelSelectionModalReturnState;

    constructor(private readonly channelPresetService: IChannelSelectionPresetService) {}

    public activateModal(
        state: ChannelSelectionModalState,
        modalInstance: IWorkflowModuleModalInstance<ChannelSelectionModalState, ChannelSelectionModalReturnState>
    ): void {
        this.modalInstance = modalInstance;
        this.frontEnd = state.frontEnd;
        this.presets = this.channelPresetService.getPresets(this.frontEnd);
    }

    public close(): ChannelSelectionModalReturnState {
        this.modalInstance = undefined;
        return this.returnState;
    }

    protected select(preset: ChannelSelection) {
        this.returnState = { selectedSelection: preset };
        this.modalInstance.close();
    }
}

// View-Model for modal needs to be first class in the file
export class ChannelSelectionModalState {
    public frontEnd: FrontEnd;
}

export class ChannelSelectionModalReturnState {
    public selectedSelection: ChannelSelection;
}
